import React, { useState, useEffect, useRef } from "react";
import VehicleFilters from "./VehicleFilters";
import { getVehicles } from "../services/vehicleInvoiceService";
import "../styles/vehicletable.css";
import { searchVehicleByChassis } from "../services/vehicleSearchService";
import { getVehicleDetail } from "../services/vehicleStockDetailService";

function VehicleTable({ onSelect }) {

  const [vehicles, setVehicles] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const [filter, setFilter] = useState("active");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const scrollRef = useRef(null);

  useEffect(() => {
  if (filter !== "search") {
    loadVehicles();
  }
}, [filter, fromDate, toDate]);

  const loadVehicles = async () => {
    try {
      let type = 1;
      if (filter === "active") type = 1;
      if (filter === "all") type = 2;
      if (filter === "completed") type = 3;

      const data = await getVehicles(type, fromDate, toDate);
      setVehicles(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Vehicle API error:", error);
    }
  };

  const handleSearch = async (chassisNo) => {
  try {
    const vehicles = await searchVehicleByChassis(chassisNo);

    setVehicles(Array.isArray(vehicles) ? vehicles : []);

    // Auto-load first result detail
    if (vehicles && vehicles.length > 0) {
      const firstVehicle = vehicles[0];

      setSelectedId(firstVehicle.chassis_no);

      const detail = await getVehicleDetail(firstVehicle.vehicle_id);

      onSelect(detail);
    }
  } catch (error) {
    console.error("Search error:", error);
  }
};

  const handleClick = async (vehicle) => {
  try {
    setSelectedId(vehicle.chassis_no);

    let detail;

    // Search API returns vehicle_id
    if (vehicle.vehicle_id) {
      detail = await getVehicleDetail(vehicle.vehicle_id);
    } else {
      // Existing invoice cards
      detail = vehicle;
    }

    onSelect(detail);
  } catch (error) {
    console.error("Detail error:", error);
  }
};

  // 👉 Scroll control
  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount = 280;

    if (direction === "left") {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  const getProxyImage = (url) => {
  if (!url) return "/no-image.png";

  const imagePath = url.split(":8080/")[1];

  return imagePath
    ? `/vehicle-images/${imagePath}`
    : "/no-image.png";
};

  return (
    <div>

      {/* FILTER */}
      <VehicleFilters
  filter={filter}
  setFilter={setFilter}
  fromDate={fromDate}
  setFromDate={setFromDate}
  toDate={toDate}
  setToDate={setToDate}
  onSearch={handleSearch}
/>

      {/* ================= MOBILE CAROUSEL ================= */}
      <div className="mobile-carousel d-md-none">

        <div className="carousel-wrapper">

          {/* LEFT ARROW */}
          <button className="carousel-btn left" onClick={() => scroll("left")}>
            ‹
          </button>

          {/* SCROLL AREA */}
          <div className="carousel-scroll" ref={scrollRef}>

            {vehicles.map((v) => (
              <div
                key={`${v.invoice_id}-${v.chassis_no}`}
                className={`vehicle-card carousel-card ${
                  selectedId === v.chassis_no ? "selected" : ""
                }`}
                onClick={() => handleClick(v)}
              >

                <div className="vehicle-info">
                  <h6>{v.vehicle_make} {v.vehicle_model}</h6>
                  <p>{v.invoice_no}</p>
                  <p>{v.chassis_no}</p>
                </div>

                <div className="vehicle-image">
                  <span className={`status overlay ${v.status}`}>
                    {v.status}
                  </span>

                  <img
                    src={v.photo_url && v.photo_url.endsWith(".jpg") ? v.photo_url : "/no-image.png"}
                    alt="vehicle"
                    onError={(e) => (e.target.src = "/No_Image_Available.jpeg")}
                  />
                </div>

              </div>
            ))}

          </div>

          {/* RIGHT ARROW */}
          <button className="carousel-btn right" onClick={() => scroll("right")}>
            ›
          </button>

        </div>
      </div>

      {/* ================= DESKTOP LIST ================= */}
      <div className="vehicle-card-container d-none d-md-flex">

        {vehicles.map((v) => (
          <div
            key={`${v.invoice_id}-${v.chassis_no}`}
            className={`vehicle-card ${
              selectedId === v.chassis_no ? "selected" : ""
            }`}
            onClick={() => handleClick(v)}
          >

            <div className="vehicle-info">
              <div className="vehicle-header">
                <h3>{v.vehicle_make} {v.vehicle_model}</h3>
              </div>

              <p><strong>Invoice:</strong> {v.invoice_no}</p>
              <p><strong>Date:</strong> {v.invoice_date}</p>
              <p><strong>Chassis:</strong> {v.chassis_no}</p>
            </div>

            <div className="vehicle-image">
              <span className={`status overlay ${v.status}`}>
                {v.status}
              </span>

              <img
  src={getProxyImage(v.photo_url)}
  alt="vehicle"
  loading="lazy"
      decoding="async"
  onError={(e) => {
    e.target.src = "/No_Image_Available.jpeg";
  }}
/>
            </div>

          </div>
        ))}

      </div>

    </div>
  );
}

export default VehicleTable;